import React, { useEffect, useRef, useState } from "react";

const ACTIVE_TAB_KEY = "app_active_tab_lock_v3";
const CHANNEL_NAME = "app_multi_tab_channel_v3";
const HEARTBEAT_MS = 1000;

const MultiTabSessionGuard = () => {
  const [blocked, setBlocked] = useState(false);
  const tabIdRef = useRef(
    `${Date.now()}_${Math.random().toString(36).slice(2)}`,
  );

  // console.log("Dasdasdasdasdas")
  const channelRef = useRef(null);

  const writeActiveTab = () => {
    localStorage.setItem(
      ACTIVE_TAB_KEY,
      JSON.stringify({
        tabId: tabIdRef.current,
        time: Date.now(),
      }),
    );
  };

  const blockThisTab = () => {
    console.log("BLOCKING TAB:", tabIdRef.current);
    setBlocked(true);
  };

  const notifyTabs = () => {
    const message = {
      type: "NEW_TAB_ACTIVE",
      tabId: tabIdRef.current,
      time: Date.now(),
    };

    channelRef.current?.postMessage(message);

    localStorage.setItem(
      `${ACTIVE_TAB_KEY}_signal`,
      JSON.stringify({
        ...message,
        nonce: Math.random(),
      }),
    );
  };

  useEffect(() => {
    channelRef.current = new BroadcastChannel(CHANNEL_NAME);

    channelRef.current.onmessage = (event) => {
      const message = event.data;

      if (!message || message.tabId === tabIdRef.current) return;

      if (message.type === "NEW_TAB_ACTIVE") {
        blockThisTab();
      }
    };

    const onStorage = (event) => {
      if (event.key !== `${ACTIVE_TAB_KEY}_signal`) return;
      if (!event.newValue) return;

      const message = JSON.parse(event.newValue);

      if (message.tabId !== tabIdRef.current) {
        blockThisTab();
      }
    };

    window.addEventListener("storage", onStorage);

    writeActiveTab();
    notifyTabs();

    const heartbeat = setInterval(() => {
      if (!blocked) {
        writeActiveTab();
      }
    }, HEARTBEAT_MS);

    return () => {
      clearInterval(heartbeat);
      window.removeEventListener("storage", onStorage);
      channelRef.current?.close();
    };
  }, []);

  const handleOk = () => {
    localStorage.removeItem(ACTIVE_TAB_KEY);
    localStorage.removeItem(`${ACTIVE_TAB_KEY}_signal`);

    setBlocked(false);
    window.close();
    window.location.replace("about:blank");
  };

  if (!blocked) return null;

  return (
    <div className="fixed inset-0 z-[999999999] flex items-center justify-center bg-black/80 px-4">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 text-center shadow-2xl">
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-red-100 text-4xl">
          ⚠️
        </div>

        <h2 className="mb-3 text-xl font-bold text-gray-900">
          Another Session Is Active
        </h2>

        <p className="mb-6 text-sm leading-6 text-gray-600">
          This account is already active in another browser tab. Only one tab is
          allowed at a time.
        </p>

        <button
          type="button"
          onClick={handleOk}
          className="w-full rounded-xl bg-red-600 px-5 py-3 font-semibold text-white"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default MultiTabSessionGuard;
